"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var Avatar_1 = __importDefault(require("../../Avatar"));

var config_1 = require("../../config");

var Profile =
/** @class */
function (_super) {
  __extends(Profile, _super);

  function Profile() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.onMenuItemClick = function (e) {
      var id = e.currentTarget.getAttribute('data-id');

      if (id) {
        _this.props.onChange(id);
      }
    };

    return _this;
  }

  Profile.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        items = _a.items,
        active = _a.active,
        className = _a.className,
        imageUrl = _a.imageUrl;
    var b = config_1.block('profile');
    var menuItems = items.map(function (item) {
      return react_1.default.createElement("li", {
        key: "item-" + item.id,
        className: b('submenu__item', {
          active: item.id === active
        })
      }, react_1.default.createElement("a", {
        "data-id": item.id,
        onClick: _this.onMenuItemClick
      }, item.label));
    });
    return react_1.default.createElement("div", {
      className: b({}).mix(className)
    }, react_1.default.createElement(Avatar_1.default, {
      uri: imageUrl,
      size: 32
    }), react_1.default.createElement("ul", {
      className: b('submenu')
    }, menuItems));
  };

  return Profile;
}(react_1.default.Component);

exports.default = Profile;